import React__default from 'react';
import MultipleImageWeb from '../Components/Cells/MultipleImageCarousal/Web/multiple-image-web.js';
import MultipleImageMobile from '../Components/Cells/MultipleImageCarousal/Web/multiple-image-mobile.js';
import classNames from './../external_lib/classnames/index.js';
import { useIsMobile } from '../Utils/isMobile.util.js';

function MultipleImageCarosel(_a) {
    var classes = _a.classes, imageList = _a.imageList, topExtras = _a.topExtras, imageComponent = _a.imageComponent;
    var isMobile = useIsMobile();
    return (React__default.createElement("div", { className: classNames('multiple-image-carousel', classes) }, !isMobile ? (React__default.createElement(MultipleImageWeb, { imageList: imageList, topExtras: topExtras, imageComponent: imageComponent })) : (React__default.createElement(MultipleImageMobile, { imageList: imageList, topExtras: topExtras, imageComponent: imageComponent }))));
}

export { MultipleImageCarosel as default };
//# sourceMappingURL=MultipleImageCarousal.js.map
